import WorkspaceClass from "../../service/workspace";
import { isCompressionGZ } from "../../util/common";
import { addDataSources, clearDataSources } from "./dataSource";
import { setProcessQueue, syncProcessQueue } from "./processQueue";
import {
  CLEAR_RUNNING_IMPORTS,
  COMPLETE_RUNNING_IMPORTS,
  TOGGLE_SIDE_NAV,
  OPEN_POPUP,
  CLOSE_POPUP,
  HIDE_MAPPING,
  HIDE_TOAST,
  SET_NOTIFICATIONS,
  SET_CONFIG,
  SET_PERMISSION,
  SET_RUNNING_IMPORTS,
  SET_USER,
  SHOW_MAPPING,
  SHOW_TOAST,
  SYNC_NOTIFICATIONS,
  SET_MANAGE_CASES,
  SET_ENTITY_LOOKUP,
  SET_CUSTOM_SEARCH,
} from "./types";

//Set User
export const setUser = (user) => {
  return {
    type: SET_USER,
    payload: {
      currentUser: user,
    },
  };
};

export const setConfig = (config) => {
  return {
    type: SET_CONFIG,
    payload: {
      config,
    },
  };
};

//Set Permissions
export const setPermission = (permissions) => {
  return {
    type: SET_PERMISSION,
    payload: permissions,
  };
};

// Open Popup available in redux
export const openPopup = (payload) => {
  return {
    type: OPEN_POPUP,
    payload,
  };
};

// Close Popup available in redux
export const closePopup = (payload) => {
  return {
    type: CLOSE_POPUP,
    payload,
  };
};

// Side Navbar toggle
export const sideNavToggle = () => {
  return {
    type: TOGGLE_SIDE_NAV,
  };
};

//Toast show/hide
export const showToast = (payload) => {
  return {
    type: SHOW_TOAST,
    payload,
  };
};

export const hideToast = () => {
  return {
    type: HIDE_TOAST,
  };
};

const setRunningProcesses = (payload) => {
  return {
    type: SET_RUNNING_IMPORTS,
    payload,
  };
};

export const completeRunningProcesses = (payload) => {
  return {
    type: COMPLETE_RUNNING_IMPORTS,
    payload,
  };
};

export const clearRunningProcesses = (payload) => {
  return {
    type: CLEAR_RUNNING_IMPORTS,
    payload,
  };
};

export const showMappingPopup = () => {
  return {
    type: SHOW_MAPPING,
  };
};

export const hideMappingPopup = () => {
  return {
    type: HIDE_MAPPING,
  };
};

//Upoading file
export const upload = async (dispatch, payload) => {
  const {
    Workspace_id,
    uploadedFile,
    delimeter,
    nullValue,
    fieldEnclosedBy,
    encoding,
    hasHeaderRow,
    schemaName,
    tableName,
    append,
    fileType,
    fields,
    destinationAction,
    onError,
    onErrorNumber,
    dataSource,
    connection,
    dsFromQuickImport = false,
    unloadEnabled,
    unloadConnection,
    unloadPath,
  } = payload;

  try {
    const workspace = new WorkspaceClass();

    //Generating unique token
    const token = Date.now();

    let chunkCounter = 0;
    //breaking file into 50 MB chunks
    const chunkSize = 50000000;
    const numberofChunks = Math.ceil(uploadedFile.size / chunkSize);

    let start = 0;
    let chunkEnd = start + chunkSize;
    const isTypeGZ = await isCompressionGZ(uploadedFile);

    //Upload chunk function
    const uploadChunk = async (formData, start, chunkEnd) => {
      const blobEnd = chunkEnd - 1;

      const response = await workspace.loadLocalFile(
        Workspace_id,
        formData,
        token,
        {
          "Content-Range": "bytes " + start + "-" + blobEnd + "/" + uploadedFile.size,
        },
        {
          onUploadProgress: (data) => {
            const runningProcesses = Math.round(
              (100 * (chunkSize * (chunkCounter - 1) + data.loaded)) / uploadedFile.size
            );

            //Set the progress value to show the progress bar
            dispatch(
              setRunningProcesses({
                historyId: token,
                workspace: Workspace_id,
                filename: uploadedFile.name,
                runningProcesses: runningProcesses <= 100 ? runningProcesses : 100,
                schemaName,
                tableName,
                type: "local",
              })
            );
          },
        }
      );

      start += chunkSize;
      //if start is smaller than file size - we have more to still upload
      if (start < uploadedFile.size) {
        //create the new chunk
        if (response.success) createChunk(start);
        else
          dispatch(
            completeRunningProcesses({
              historyId: token,
              success: false,
              error: response.errors[0],
            })
          );
      } else {
        dispatch(
          setRunningProcesses({
            historyId: token,
            newHistoryId: response.data,
            workspace: Workspace_id,
            filename: uploadedFile.name,
            runningProcesses: null,
            schemaName,
            tableName,
            type: "cloud",
          })
        );
      }
    };

    //Creating chunks
    const createChunk = (start) => {
      chunkCounter++;
      chunkEnd = Math.min(start + chunkSize, uploadedFile.size);

      //Slicing file
      const chunk = uploadedFile.slice(start, chunkEnd);
      const formData = new FormData();

      formData.append("file", chunk, uploadedFile.name);
      formData.append("isCompressionGZ", isTypeGZ);
      formData.append("lastChunk", numberofChunks === chunkCounter);
      formData.append("chunkNo", chunkCounter);
      formData.append("totalSize", uploadedFile.size);
      formData.append("fileType", fileType);
      formData.append("dsFromQuickImport", dsFromQuickImport);

      //Appending other params if file is last
      if (numberofChunks === chunkCounter) {
        formData.append("delimiter", delimeter);
        formData.append("nullValue", nullValue);
        formData.append("fieldEnclosedBy", fieldEnclosedBy);
        formData.append("encoding", encoding);
        formData.append("hasHeaderRow", hasHeaderRow);
        formData.append("schemaName", schemaName);
        formData.append("tableName", tableName);
        formData.append("append", append);
        formData.append("fields", fields);
        formData.append("destinationAction", destinationAction);
        formData.append("onError", onError);
        formData.append("onErrorNumber", onErrorNumber);
        formData.append("uploadType", "local");
        formData.append("dataSource", dataSource);
        formData.append("connection", connection);
        formData.append("unloadEnabled", unloadEnabled);
        formData.append("unloadConnection", unloadConnection);
        formData.append("unloadPath", unloadPath);
      }

      //created the chunk, now upload iit
      uploadChunk(formData, start, chunkEnd);
    };

    //uploading the first chunk
    createChunk(start);
  } catch (error) {
    dispatch(
      completeRunningProcesses({
        workspace: Workspace_id,
        schemaName,
        tableName,
        success: false,
        error: error.message,
      })
    );
  }
};

//Importing file from cloud storage
export const loadFromCloudStorage = async (dispatch, payload) => {
  const {
    Workspace_id,
    fileName,
    location,
    delimeter,
    nullValue,
    fieldEnclosedBy,
    encoding,
    hasHeaderRow,
    schemaName,
    tableName,
    append,
    fileType,
    fields,
    bucket,
    s3Prefix,
    destinationAction,
    onError,
    onErrorNumber,
    dataSource,
    connection,
    dsFromQuickImport = false,
    unloadEnabled,
    unloadConnection,
    unloadPath,
  } = payload;

  try {
    const workspace = new WorkspaceClass();
    const response = await workspace.loadDataConnectionData(Workspace_id, {
      fields,
      delimeter,
      nullValue,
      schemaName,
      fieldEnclosedBy,
      encoding,
      tableName,
      fileName,
      location,
      append,
      fileType,
      hasHeaderRow,
      bucket,
      s3Prefix,
      destinationAction,
      onError,
      onErrorNumber,
      dataSource,
      connection,
      dsFromQuickImport,
      uploadType: "cloud",
      unloadEnabled,
      unloadConnection,
      unloadPath,
    });

    dispatch(
      setRunningProcesses({
        historyId: response.data,
        workspace: Workspace_id,
        filename: fileName,
        runningProcesses: null,
        schemaName,
        tableName,
        type: "cloud",
      })
    );
  } catch (error) {
    dispatch(
      completeRunningProcesses({ workspace: Workspace_id, schemaName, tableName, success: false, error: error.message })
    );
  }
};

export const setNotifications = (payload) => {
  return {
    type: SET_NOTIFICATIONS,
    payload,
  };
};

export const syncNotifications = (payload) => {
  return {
    type: SYNC_NOTIFICATIONS,
    payload,
  };
};

export const setManageCasesSelection = (payload) => {
  return {
    type: SET_MANAGE_CASES,
    payload,
  };
};

export const setEntityLookupSelection = (payload) => {
  return {
    type: SET_ENTITY_LOOKUP,
    payload,
  };
};

export const setCustomSearch = (payload) => {
  return {
    type: SET_CUSTOM_SEARCH,
    payload,
  };
};

export { addDataSources, clearDataSources, setProcessQueue, syncProcessQueue };
